import React, { Component } from 'react';
import ResetForm from './ResetForm';
import Wrapper from './style';

class Password extends Component {
	state = {
		num: parseInt((Math.random() * 100) % 11, 10) + 1
	};
	render() {
		return (
			<Wrapper>
				<h2>Password Reset</h2>
				<ResetForm history={this.props.history} />
			</Wrapper>
		);
	}
}

export default Password;
